export default {"src":"/_next/static/media/GPS.36acae50.svg","height":18,"width":18};